export const RADIO_OVERWRITE = {
  classNames: {
    Root: 'grid gap-2',
    GroupItem: `
      relative h-4 w-4 rounded-full border border-neutral-200 hover:border-2
      ring-offset-background focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2
      disabled:cursor-not-allowed disabled:text-neutral-100 disabled:border-neutral-100
      data-[state=checked]:border-2 data-[state=checked]:border-primary-600 data-[state=checked]:text-primary-600 data-[state=checked]:hover:border-primary-500 data-[state=checked]:hover:text-primary-500
      data-[state=checked]:disabled:border-primary-200 data-[state=checked]:disabled:text-primary-200
    `,

    GroupIndicator: 'flex items-center justify-center w-full h-full',
    Icon: 'h-1.5 w-1.5 rounded-full bg-current',
  },
};
